import React, { useEffect, useMemo } from "react";
import { getOneService, updateService } from "@payping/redux/actions";
import { DashboardRoutes } from "@/router/constant";
import {
  Button,
  Col,
  Drawer,
  Flex,
  LegacyForm,
  Row,
  Skeleton,
  Space,
  Typography,
  useMessagedAsync,
  useMessagedAsyncFn,
} from "@payping/web-components";
import { Link, useNavigate } from "react-router-dom";
import { useAppDispatch, useAppSelector } from "@/utils/redux";
import { useAppTranslation } from "@/utils/useAppTranslation";
import styles from "@/assets/scss/profile/Settings.module.scss";
import { Close } from "@payping/icons";
import { SwitchRow } from "@/core/component";

interface MessagingFormType {
  getImportantNotifies: boolean;
  getPayNotify: boolean;
  sendInvoiceReminder: boolean;
}
const MobileProfileMessaging: React.FC = () => {
  const { profile } = DashboardRoutes;
  const { t } = useAppTranslation();
  const dispatch = useAppDispatch();
  const oneService = useAppSelector((state) => state.service.oneService);
  const [form] = LegacyForm.useForm<MessagingFormType>();
  const navigate = useNavigate();

  const { loading: loadingGet } = useMessagedAsync(
    async () => {
      await dispatch(getOneService(11));
    },
    [dispatch],
    { useProgress: true },
  );

  const [{ loading: loadingEdit }, handleEdit] = useMessagedAsyncFn(
    async (values: MessagingFormType) => {
      await dispatch(updateService({ ...values, serviceType: 11 }));
      navigate(DashboardRoutes.profile.detail.url);
    },
    [dispatch, navigate],
    undefined,
    { useProgress: true },
  );

  const loading = useMemo(() => loadingGet || loadingEdit, [loadingGet, loadingEdit]);

  useEffect(() => {
    form.setFieldsValue({
      getImportantNotifies: oneService.getImportantNotifies,
      getPayNotify: oneService.getPayNotify,
      sendInvoiceReminder: oneService.sendInvoiceReminder,
    });
  }, [form, oneService]);

  return (
    <Drawer
      open
      title={t("settings.cards.notifications.title")}
      size={"100%"}
      placement={"bottom"}
      closeIcon={false}
      extra={
        <Button
          type={"text"}
          icon={<Close width={14} height={14} />}
          onClick={() => {
            navigate(profile.mRoot.url);
          }}
        />
      }
      footer={
        <Flex gap={"small"} className="tw:flex tw:justify-end">
          <Link to={DashboardRoutes.profile.root.url}>
            <Button variant={"outlined"} color="primary">
              {t("return")}
            </Button>
          </Link>
          <Button type={"primary"} loading={loading} onClick={() => form.submit()} htmlType={"submit"}>
            {t("enable")}
          </Button>
        </Flex>
      }
    >
      <Space orientation={"vertical"} size={"middle"} className={"tw:w-full"}>
        <Row className={"tw:w-full"}>
          <Col xs={24} sm={20} md={16} lg={12} xl={10}>
            <LegacyForm onFinish={handleEdit} form={form}>
              <Typography.Text className={styles.grey}>{t("settings.messaging.email.title")}</Typography.Text>
              <LegacyForm.Item name={"getPayNotify"} valuePropName={"checked"}>
                {loading ? (
                  <Skeleton.Input />
                ) : (
                  <SwitchRow size={"small"} label={t("settings.messaging.email.payMessage")} />
                )}
              </LegacyForm.Item>
              <LegacyForm.Item name={"getImportantNotifies"} valuePropName={"checked"}>
                {loading ? (
                  <Skeleton.Input />
                ) : (
                  <SwitchRow size={"small"} label={t("settings.messaging.email.importantOrAuth")} />
                )}
              </LegacyForm.Item>
              <Typography.Text className={styles.grey}>{t("settings.messaging.sms.title")}</Typography.Text>
              <LegacyForm.Item name={"sendInvoiceReminder"} valuePropName={"checked"}>
                {loading ? (
                  <Skeleton.Input />
                ) : (
                  <SwitchRow size={"small"} label={<Col span={19}>{t("settings.messaging.sms.invoiceLink")}</Col>} />
                )}
              </LegacyForm.Item>
            </LegacyForm>
          </Col>
        </Row>
      </Space>
    </Drawer>
  );
};

export default MobileProfileMessaging;
